import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import pt from 'vuetify/es5/locale/pt'
import { getCurrentClient, getBrand } from '@/config/brand'

Vue.use(Vuetify)

const brand = getBrand(getCurrentClient())

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#00985E',
        secondary: '#f0f6fb',
        tertiary: '#dee8fc',
        soft: '#f7f7f7',
        loginTheme: brand.colors.loginTheme,
      },
    },
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
})
